/**
 *
 * To create new scripts create a partial inside src and write your code there either inside
 * a function or object oriented.
 *
 * Then call it on the relevant page below or in the common function to be run on every page.
 *
 */

//Utilities
import AjaxForm from "./common/ajax-form";
import Masonry from "./common/masonry";
import ScrollToId from "./common/scroll-to-id";
import ScrollToError from "./common/scroll-to-error";

//Vendor
import Magnific from "./common/magnific";

// pkrxiv doi input change
import GravityFormDoiChange from "./pkrxiv/gravityform-doi-change";

// data items pagination
import AccountPagination from "./pkrxiv/account-pagination";

// main nav js
import MainNav from "./pkrxiv/main-nav";

// data card feed
import DataCardsFeedClick from "./pkrxiv/data-cards-feed";

// data cards index page
import DataCardsIndex from "./pkrxiv/data-cards-index";

// check for incomplete forms
import IncompleteForms from "./pkrxiv/incomplete-forms";

window.$ = window.jQuery; // Set JQuery Variable

window.tdScrollLock = (lock) => {
    document.documentElement.classList.toggle("is-scroll-locked", lock);
};

window.addEventListener("scroll", function () {
    document.documentElement.style.setProperty(
        "--td--window--scroll",
        window.scrollY
    );
});


var App = {
    // All pages
    common: {
        init: function () {
            new AjaxForm();
            new ScrollToId();
            new ScrollToError();
            new Magnific();
            new Masonry();
            new GravityFormDoiChange();
            new AccountPagination();
            new MainNav();
            new DataCardsFeedClick();
            new DataCardsIndex();
            new IncompleteForms();
        }
    },
    // Home page
    home: {
        init: function () {
            // JavaScript to be fired on the home page
        }
    },
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
    fire: function (func, funcname, args) {
        var namespace = App;
        funcname = funcname === undefined ? "init" : funcname;
        if (
            func !== "" &&
            namespace[func] &&
            typeof namespace[func][funcname] === "function"
        ) {
            namespace[func][funcname](args);
        }
    },
    loadEvents: function () {
        UTIL.fire("common");

        $.each(
            document.body.className.replace(/-/g, "_").split(/\s+/),
            function (i, classnm) {
                UTIL.fire(classnm);
            }
        );
    }
};

$(document).ready(UTIL.loadEvents());
